import {
    getSurvicateInstance,
    initSurvicate
} from '@survicate/survicate-web-surveys-wrapper/widget_wrapper';

const SURVICATE_TRIGGER_ATTRIBUTE = 'data-trigger-survicate-event';

export interface SurvicateEventServiceConfig {
    workspaceKey: string;
}

export default class SurvicateEventService {
    static #instance: SurvicateEventService | null = null;

    readonly #locale: string = document.documentElement.dataset.icuLocale ?? 'nl_NL';

    #initialized = false;

    public static getInstance(): SurvicateEventService {
        if (this.#instance === null) {
            this.#instance = new SurvicateEventService();
        }

        return this.#instance;
    }

    public static destroyInstance(): void {
        this.#instance = null;
    }

    public async init(config: SurvicateEventServiceConfig): Promise<void> {
        if (this.#initialized) {
            return;
        }
        try {
            await initSurvicate({
                workspaceKey: config.workspaceKey,
                forcedLanguage: this.#locale
            });
        } catch (err) {
            throw err;
        }
        this.#initialized = true;
        this.#bindElements();
    }

    #bindElements(): void {
        const selector = `[${SURVICATE_TRIGGER_ATTRIBUTE}]`;
        const elements = document.querySelectorAll<HTMLElement>(selector);

        for (const element of elements) {
            const eventName = element.getAttribute(SURVICATE_TRIGGER_ATTRIBUTE);

            if (!eventName || eventName.trim() === '') {
                continue;
            }

            element.removeAttribute('hidden');
            element.addEventListener('click', () => this.#invokeEvent(eventName.trim()));
        }
    }

    #invokeEvent(eventName: string): void {
        const survicate = getSurvicateInstance();
        if (survicate === null) {
            return;
        }

        survicate.invokeEvent(eventName);
    }
}
